"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnexionButton = exports.FavoriteButton = exports.FullscreenButton = exports.MuteButton = exports.SystemActionButton = void 0;
const react_1 = __importDefault(require("react"));
const rn_css_1 = __importStar(require("rn-css"));
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const base_ui_elements_icon_1 = require("@unboared/base-ui.elements.icon");
const StyleSystemActionButton = rn_css_1.default.TouchableOpacity `
`;
const SystemActionButton = ({ onIcon, offIcon, size, onPress, active }) => {
    const theme = (0, rn_css_1.useTheme)();
    const currentTheme = theme || base_ui_theme_themes_1.defaultTheme;
    return (react_1.default.createElement(StyleSystemActionButton, { active: active, onPress: onPress },
        react_1.default.createElement(base_ui_elements_icon_1.Icon, { name: (active ? onIcon : offIcon), color: (active ? currentTheme.color.primary : currentTheme.buttonTextColor), size: size })));
};
exports.SystemActionButton = SystemActionButton;
const MuteButton = ({ size = 20, onPress, active }) => {
    return (react_1.default.createElement(exports.SystemActionButton, { onIcon: "volumeOn", offIcon: "volumeOff", size: size, onPress: onPress, active: active }));
};
exports.MuteButton = MuteButton;
const FullscreenButton = ({ size = 20, onPress, active }) => {
    return (react_1.default.createElement(exports.SystemActionButton, { onIcon: "fullscreenOff", offIcon: "fullscreenOn", size: size, onPress: onPress, active: active }));
};
exports.FullscreenButton = FullscreenButton;
const FavoriteButton = ({ size = 20, onPress, active }) => {
    return (react_1.default.createElement(exports.SystemActionButton, { onIcon: "favoriteOn", offIcon: "favoriteOff", size: size, onPress: onPress, active: active }));
};
exports.FavoriteButton = FavoriteButton;
const ConnexionButton = ({ size = 20, onPress, active }) => {
    return (react_1.default.createElement(exports.SystemActionButton, { onIcon: "qrcode", offIcon: "qrcode", size: size, onPress: onPress, active: active }));
};
exports.ConnexionButton = ConnexionButton;
//# sourceMappingURL=system_action_button.js.map